export const FINANCE_INVOICE_STATUS = {
  ALL: "all",
  OPEN: "open",
  FAILED: "failed",
  COMPLETED: "completed",
};

export const normalizeFinanceInvoiceStatus = (invoice = {}) => {
  const status = String(invoice?.invoiceStatus || invoice?.paymentStatus || "").trim().toLowerCase();
  if (["completed", "paid", "success", "succeeded"].includes(status)) return FINANCE_INVOICE_STATUS.COMPLETED;
  if (["failed", "error"].includes(status)) return FINANCE_INVOICE_STATUS.FAILED;
  if (["open", "pending", "unpaid", "partially_paid", "partially paid"].includes(status)) return FINANCE_INVOICE_STATUS.OPEN;
  return status;
};

export const filterFinanceInvoicesByStatus = (invoices = [], status = FINANCE_INVOICE_STATUS.ALL) => {
  const normalizedFilter = String(status || FINANCE_INVOICE_STATUS.ALL).trim().toLowerCase();
  if (normalizedFilter === FINANCE_INVOICE_STATUS.ALL) return Array.isArray(invoices) ? invoices : [];
  return (Array.isArray(invoices) ? invoices : [])
    .filter((invoice) => normalizeFinanceInvoiceStatus(invoice) === normalizedFilter);
};
